
<div class="cmp-contact-form-os">
  <template v-if="!licenseOnly">
    <h6>
      {{ $t('product.properties.os.title') }}
    </h6>
    <ws-select
      v-model="model"
      class="q-mt-md"
      :options="options"
      option-value="type"
      :disable="!inEdit"
      :rules="[requiredOsValidator]"
    >
      <template
        v-for="slotName in ['selected', 'option']"
        :slot="slotName"
        slot-scope="scope"
      >
        <q-item
          :key="slotName + scope.index"
          v-bind="scope.itemProps"
          :class="{
            'q-pl-none': slotName === 'selected',
          }"
          v-on="scope.itemEvents"
        >
          <q-item-section>
            <q-item-label>
              <span
                :class="{ 'text-ws-base100': !scope.opt && !model }"
              >{{ getOsLabel(scope) }}</span>
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </ws-select>
    <!-- <p v-else class="text-ws-base150 q-mt-md">
      {{
        $t(getKey('properties.os.' + model.type, 'label'), {
          _fallback: model.name,
          _silent: true,
        })
      }}
    </p> -->
  </template>
  <transition name="slide-fade-vertical">
    <div
      v-if="get(model, 'licences.length') || (!inEdit && licences.length)"
      class="licences"
    >
      <hr v-if="!licenseOnly" class="ws-default q-my-lg" />

      <h6 class="q-mt-2xl">
        {{ $t('product.properties.os.licences_title') }}
      </h6>

      <component
        :is="inEdit ? WsCheckbox : ListItemCmp"
        v-for="licence in inEdit ? model.licences : licences"
        :key="licence.type"
        v-model="licencesModel"
        :val="licence"
        :checked="licence.required"
        :disable="licence.required || !inEdit"
        class="q-mt-lg q-mb-sm text-bold"
        full-width
      >
        <template v-slot>
          <!-- standalone licence product -->
          <span
            v-if="licenseOnly"
            class="text-ws-base150"
            :class="{ ['text-normal']: !inEdit }"
          >{{ $t(getKey(licence.code, 'title')) }}</span>
          <span
            v-else
            class="text-ws-base150"
            :class="{ ['text-normal']: !inEdit }"
          >{{ getLicenseLabel(licence) }}</span> &nbsp;
          <price-period
            :plain="!licences.includes(licence)"
            :prices="licence.prices"
            :price="licence.price"
            individual
            :period="period"
          />
        </template>
      </component>
    </div>
  </transition>
</div>
